import { apiService, handleResponse } from '@/services/apiService';

export class BigBagRepository {
    async getBigBags(data: { userId?: number | null }) {
        const response = await apiService.get(`/v1/bigbags`, { params: data });
        return handleResponse(response);
    }
}